export default __webpack_public_path__ + "static/media/s4_xit-autumn.f4928f71.png";